import produce, { castDraft, } from 'immer';
import { EventLogsActionType, } from './actions';
const tsDataByIdByHomeIdByTSDBModuleIdBySearchParamsReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case EventLogsActionType.SET_EVENT_LOGS_DATA:
            return produce(currentState, (draft) => {
                const actualAction = action;
                const temp = draft[actualAction.homeId] || {};
                draft[actualAction.homeId] = temp;
                const temp2 = temp[actualAction.logResourcePath] || {};
                temp[actualAction.logResourcePath] = temp2;
                temp2[actualAction.searchParams] = castDraft(actualAction.data);
            });
        case EventLogsActionType.CLEAR_EVENT_LOGS_DATA:
            return produce(currentState, (draft) => {
                const actualAction = action;
                const eventLogsByHomeId = draft[actualAction.homeId];
                if (eventLogsByHomeId) {
                    eventLogsByHomeId[actualAction.logResourcePath] = {};
                }
            });
        default:
            return currentState;
    }
};
export const eventLogsStateReducer = (currentState, action) => {
    return produce(currentState, (draft) => {
        draft.eventLogDataByHomeIdByLogResourcePathBySearchParams = castDraft(tsDataByIdByHomeIdByTSDBModuleIdBySearchParamsReducer(currentState.eventLogDataByHomeIdByLogResourcePathBySearchParams, action));
    });
};
